<template>
  <el-card class="product-general-info mb-4" shadow="hover">
    <div slot="header" class="d-flex justify-content-between align-items-center">
      <span class="font-weight-bold title">1. Thông tin chung (Product)</span>
      <div>
        <el-button type="primary" size="mini" icon="el-icon-edit" @click="openUpdateDialog">
          Cập nhật
        </el-button>
        <el-button type="danger" size="mini" icon="el-icon-delete" :loading="deleting" @click="handleDelete">
          Xóa
        </el-button>
      </div>
    </div>

    <el-descriptions :column="2" border>
      <el-descriptions-item label="ID Product">
        {{ product.id || product._id || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="Mã Code">
        <el-tag type="info">{{ product.code || '-' }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="Loại Product">
        <el-tag>{{ product.type || 'tour' }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="Organization ID">
        {{ product.organization_id || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="Giá cơ bản">
        <strong style="color: #67C23A;">
          {{ formatPrice(product.base_price) }} {{ product.currency || 'VND' }}
        </strong>
      </el-descriptions-item>
      <el-descriptions-item label="Chế độ Sức chứa">
        <el-tag :type="product.capacity_mode === 'unlimited' ? 'success' : 'warning'">
          {{ product.capacity_mode || 'unlimited' }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="Yêu cầu đặt trước">
        <el-tag :type="product.requires_prebook ? 'success' : 'danger'">
          {{ product.requires_prebook ? 'Có' : 'Không' }}
        </el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="Thời gian tạo">
        {{ product.created_at || product.createdAt || '-' }}
      </el-descriptions-item>
    </el-descriptions>

    <!-- Dialog Cập nhật Product -->
    <el-dialog
      title="Cập nhật Thông tin Product"
      :visible.sync="updateDialogVisible"
      width="500px"
      append-to-body
    >
      <el-form ref="updateForm" v-loading="updating" :model="updateForm" label-width="170px">
        <el-form-item label="Giá cơ bản">
          <el-input-number v-model="updateForm.base_price" :min="0" style="width: 100%;" />
        </el-form-item>
        <el-form-item label="Đơn vị tiền tệ">
          <el-select v-model="updateForm.currency" style="width: 100%;">
            <el-option label="VND" value="VND" />
            <el-option label="USD" value="USD" />
            <el-option label="EUR" value="EUR" />
          </el-select>
        </el-form-item>
        <el-form-item label="Yêu cầu đặt trước">
          <el-switch v-model="updateForm.requires_prebook" />
        </el-form-item>
        <el-form-item label="Chế độ sức chứa">
          <el-select v-model="updateForm.capacity_mode" style="width: 100%;">
            <el-option label="Unlimited" value="unlimited" />
            <el-option label="Finite" value="finite" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false">Hủy</el-button>
        <el-button type="primary" :loading="updating" @click="handleUpdate">Lưu thay đổi</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { updateProduct, deleteProduct } from '@/services/product'

export default {
  name: 'ProductGeneralInfo',
  props: {
    product: {
      type: Object,
      required: true
    },
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      deleting: false,
      updating: false,
      updateDialogVisible: false,
      updateForm: {
        base_price: 0,
        currency: 'VND',
        requires_prebook: true,
        capacity_mode: 'unlimited'
      }
    }
  },
  methods: {
    formatPrice(val) {
      if (val === undefined || val === null) return '0'
      return Number(val).toLocaleString('vi-VN')
    },
    openUpdateDialog() {
      this.updateForm = {
        base_price: this.product.base_price || 0,
        currency: this.product.currency || 'VND',
        requires_prebook: this.product.requires_prebook !== false,
        capacity_mode: this.product.capacity_mode || 'unlimited'
      }
      this.updateDialogVisible = true
    },
    handleUpdate() {
      const productId = this.product.id || this.product._id
      this.updating = true
      updateProduct(productId, this.updateForm).then((res) => {
        const updatedData = res.data || res
        this.$message.success('Cập nhật thông tin Product thành công!')
        this.updateDialogVisible = false
        this.$emit('product-updated', { ...this.product, ...this.updateForm, ...updatedData })
      }).catch((err) => {
        const errMsg = (err && err.message) ? err.message : 'Không thể cập nhật Product'
        this.$message.error(errMsg)
      }).finally(() => {
        this.updating = false
      })
    },
    handleDelete() {
      this.$confirm('Bạn có chắc chắn muốn xóa Product này không? Thao tác này sẽ xóa liên kết booking hiện tại.', 'Cảnh báo', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        const productId = this.product.id || this.product._id
        this.deleting = true
        deleteProduct(productId).then(() => {
          this.$message.success('Xóa Product thành công!')
          this.removeFromLocale()
          this.$emit('product-deleted')
        }).catch((err) => {
          const errMsg = (err && err.message) ? err.message : 'Không thể xóa Product'
          this.$message.error(errMsg)
        }).finally(() => {
          this.deleting = false
        })
      }).catch(() => {})
    },
    removeFromLocale() {
      if (!this.detail || (!this.detail.id && !this.detail._id)) return
      const detailId = this.detail.id || this.detail._id
      try {
        const stored = localStorage.getItem('shared_booking_products')
        if (stored) {
          let mappings = JSON.parse(stored)
          mappings = mappings.filter((item) => String(item.detail_id) !== String(detailId))
          localStorage.setItem('shared_booking_products', JSON.stringify(mappings))
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
.product-general-info .title {
  font-size: 16px;
}
.d-flex {
  display: flex;
}
.justify-content-between {
  justify-content: space-between;
}
.align-items-center {
  align-items: center;
}
</style>
